import { z } from 'zod';

/**
 * The files the BO and BO external can export, each built by the backend. Requested with
 * `POST <list resource>/export`, which is authorized as listing that resource.
 */
export const BoExportKindValues = [
  /** The rows of a list, as its filters and sort select them, in a CSV */
  'list_csv',
  'savings_funds_request_orders',
  'employees_bulk',
  'employees_bulk_multi_company',
  'collective_out_transfer_affiliates',
  'b2b_contracts',
  'campaign_payouts',
  'individual_operations',
  'individual_operation_orders',
  'campaign_allocations',
  'campaign_sample',
  'vacation_days_allocations_sample',
] as const;
export const ZodBoExportKind = z.enum(BoExportKindValues);
export type BoExportKind = z.infer<typeof ZodBoExportKind>;

/**
 * The list query of a `list_csv` export, as the list endpoint takes it in its query string: the
 * export applies the list's own validation to it
 */
export const ZodBoListCsvExportBody = z.object({
  kind: z.literal('list_csv'),
  query: z.object({
    filter: z.string().optional(),
    sort: z.string().optional(),
  }),
});
export type BoListCsvExportBody = z.infer<typeof ZodBoListCsvExportBody>;

export const ZodBoExportResponse = z.object({
  document_url: z.string(),
  file_name: z.string(),
});
export type BoExportResponse = z.infer<typeof ZodBoExportResponse>;
